import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const ChefHat: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="ChefHat" stroke="#222222" strokeWidth="2">
          <path
            d="M19.604762,5.74492396 C18.5205131,5.43520006 17.3500678,5.69076678 16.5022061,6.42236702 C15.9751304,4.40828027 14.124127,3 12.0039446,3 C9.88376214,3 8.03275874,4.40828027 7.50568301,6.42236702 C6.64088202,5.68106476 5.44686385,5.43074027 4.34861579,5.76049165 C3.25036773,6.09024302 2.4038773,6.95323466 2.11043612,8.04230165 C1.84641151,9.0242256 2.0616739,10.0707189 2.69321154,10.8754515 C3.32474918,11.680184 4.30113503,12.1521403 5.33656085,12.1531691 C5.56154366,12.1446352 5.78500222,12.1130766 6.00329922,12.0590072 L6.00329922,19.6921949 C6.00329922,20.4144757 6.60031709,21 7.33677596,21 L16.6711131,21 C17.407572,21 18.0045899,20.4144757 18.0045899,19.6921949 L18.0045899,12.0590072 C18.2228994,12.1130143 18.4463513,12.1445719 18.6713283,12.1531691 C20.3284332,12.1501558 21.7318617,10.9541639 21.9662121,9.34529229 C22.2005625,7.73642066 21.1947224,6.20287361 19.604762,5.74492396 Z"
            id="Path"
          />
          <line x1="13.825661" y1="17.7097255" x2="13.825661" y2="13.6975731" id="Path" />
          <line x1="10.189298" y1="17.7097255" x2="10.189298" y2="13.6975731" id="Path-Copy" />
        </g>
      </g>
    </svg>
  );
};
